import angular from 'angular';
import CategoriesSliderFilter from './categories-slider-filter.component';

let CategoriesSliderFilterModule = angular.module('catalog.categoriesSliderFilter', [])
  .component('categoriesSliderFilter', CategoriesSliderFilter);

export default CategoriesSliderFilterModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/categories-filter/categories-slider-filter/categories-slider-filter.js
 **/